<template>
    <div class="view-competitors" :class="{ open: chart.viewCompetitors.open }">
        <div class="view-competitors-content">
            <div class="view-competitors-header">
                <h4>View Competitors from:</h4>
                <img src="../../../assets/images/close-big.svg" @click="closeViewCompetitors" alt="Close" />
            </div>
            <div class="view-competitors-separator"></div>
            <v-radio-group class="view-competitors-values" v-model="competitorsType">
                <v-radio label="Same sub-category" value="subcategories"></v-radio>
                <v-radio label="Same class" value="classes"></v-radio>
            </v-radio-group>
            <div class="view-competitors-buttons" @click="getCompetitors">
                <v-btn depressed>View Competitors</v-btn>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        chart: {
            type: Object,
        },
    },
    data() {
        return {
            competitorsType: 'subcategories',
        };
    },
    methods: {
        closeViewCompetitors() {
            this.$store.commit('chart/toggleViewCompetitors', { isOpen: false });
        },
        async getCompetitors() {
            this.closeViewCompetitors();

            const competitorsObj = {
                drugId: this.chart.viewCompetitors.drugId,
                drugName: this.chart.viewCompetitors.drugName,
                type: this.competitorsType ,
                chartType: this.chart.filters.breakApart ? this.chart.filters.parentChartType : this.chart.filters.chartType,
                cumulativeType: this.chart.filters.cumulativeType,
                startSyncView: this.chart.filters.startSyncView,
                showCumulativeRevenueChart: this.chart.filters.showCumulativeRevenueChart, 
                showLoe: this.chart.filters.showLoe, 
                colorByFicBic: this.chart.filters.colorByFicBic,
                showStopIcon: this.chart.filters.showStopIcon, 
                legendSort: this.chart.filters.legendSort,
                scaleLogType: this.chart.filters.scaleLogType,
            };

            if (this.chart.filters.breakApart) {
                competitorsObj.growthRates = [...this.chart.filters.growthRates];
                competitorsObj.growthRatesQuarters = [...this.chart.filters.growthRatesQuarters];
                competitorsObj.categories = [...this.chart.filters.categories];
            }

            if (this.chart.filters.chartType === 'new') {
                competitorsObj.range = this.chart.filters.range;
                competitorsObj.revenueFilterRange = this.chart.filters.revenueFilterRange;
                competitorsObj.cumulativeType = this.chart.filters.cumulativeType;
                competitorsObj.revenues = this.chart.filters.revenues;
            }

            await this.$store.dispatch('chart/viewCompetitors', competitorsObj);
        },
    },
};

</script>

<style lang="scss">
    @import '../../../style/Charts/ViewChart/ViewCompetitorsComponent.scss';
</style>
